import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/motion";
import { NewsCard } from "@/components/site/NewsCard";
import { NEWS } from "@/lib/news";
import { ArrowRight } from "lucide-react";

export const News = () => {
  const latest = NEWS.slice(0, 3);
  return (
    <section id="news" data-testid="news-section" className="relative py-28 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <Reveal><p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">News & Announcements</p></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
                The latest from OpenDegree.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <Link
              to="/news"
              data-testid="news-view-all-btn"
              className="group inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-ink transition-colors duration-200 hover:bg-surface"
            >
              View all news
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {latest.map((item, i) => (
            <NewsCard key={item.id} item={item} delay={i * 0.07} testid={`news-card-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
};
